/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramUsersControllerPatchPhoneMutationRequest,
  TelegramUsersControllerPatchPhoneMutationResponse,
  TelegramUsersControllerPatchPhone400,
  TelegramUsersControllerPatchPhone401,
  TelegramUsersControllerPatchPhone429,
} from '../../types/TelegramUsersControllerPatchPhone.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramUsersPatchPhone } from '../../methods/telegramUsersPatchPhone.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramUsersPatchPhoneMutationKey = () => [{ url: '/api/telegram/users/phone' }] as const;

export type TelegramUsersPatchPhoneMutationKey = ReturnType<typeof telegramUsersPatchPhoneMutationKey>;

/**
 * {@link /api/telegram/users/phone}
 */
export function useTelegramUsersPatchPhone<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramUsersControllerPatchPhoneMutationResponse,
      ResponseErrorConfig<
        | TelegramUsersControllerPatchPhone400
        | TelegramUsersControllerPatchPhone401
        | TelegramUsersControllerPatchPhone429
      >,
      { data: TelegramUsersControllerPatchPhoneMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramUsersControllerPatchPhoneMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramUsersPatchPhoneMutationKey();

  return useMutation<
    TelegramUsersControllerPatchPhoneMutationResponse,
    ResponseErrorConfig<
      TelegramUsersControllerPatchPhone400 | TelegramUsersControllerPatchPhone401 | TelegramUsersControllerPatchPhone429
    >,
    { data: TelegramUsersControllerPatchPhoneMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramUsersPatchPhone(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
